
define('jst!filefinder/_tab_filelist',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<% if(hasLinkedAccount) { %>\n\n  <div class="file-list">\n\n    <%- searchInput(\'file-list-filter-input\', searchPlaceHolderText, { \'tabindex\' : \'1\' }) %>\n\n    <div class="list-container">\n\n    </div>\n\n  </div>\n<% } else { %>\n  <div class="message-wrapper">\n    <%- button(connectButtonText, \'\', { \'class\' : \'connect-button\', \'color\': \'secondary\' }) %>\n  </div>\n<% } %>\n');
 });

